'use strict';

import angular from 'angular';
import ShowController from './show.controller';

export default angular.module('onyxReadingRoomApp.appconfs.show', [])
  .controller('AppConfsShowController', ShowController)
  .name;



// WEBPACK FOOTER //
// ./client/app/appconfs/show/index.js